import { NgModule } from '@angular/core';

import { FormatNumberPipe } from './pipes/format-number.pipe';
import { IfNullPipe } from './pipes/if-null.pipe';
import { LargeNumberPipe } from './pipes/large-number.pipe';

@NgModule({
  declarations: [FormatNumberPipe, LargeNumberPipe, IfNullPipe],
  exports: [FormatNumberPipe, LargeNumberPipe, IfNullPipe],
  providers: [FormatNumberPipe, LargeNumberPipe, IfNullPipe]
})
export class FormatModule {}
